module.exports = new __parcel__URL__("66360_h.36ea0876.jpg").toString();